import { RadioConfig, media, tokens, css } from '@sail/ui';
import { helmTokens } from '../tokens';
export const radioCustomization = RadioConfig.customize({
    uses: [
        css({
            flexGrow: 0,
            cursor: 'pointer',
            [media.up(tokens.viewport.small)]: {
                display: 'flex',
                flexBasis: 'auto',
                flexDirection: 'row-reverse'
            }
        })
    ],
    subviews: {
        input: {
            css: {
                transition: `${helmTokens.transition.hover}`,
                transitionProperty: 'box-shadow, background-color',
                boxShadow: '0 0 0 1px transparent',
                flexBasis: 'auto',
                ':hover': {
                    backgroundColor: 'rgba(99, 91, 255, 0.2)',
                    keyline: 'transparent',
                    boxShadow: '0 0 0 1px rgba(99, 91, 255, 0.2)',
                    transition: `${helmTokens.transition.hover}`,
                    transitionProperty: 'box-shadow, background-color'
                }
            }
        },
        label: {
            css: {
                cursor: 'pointer',
                fontWeight: 'normal'
            }
        }
    }
});

//# sourceMappingURL=radio.js.map